import React, {useEffect, useState} from 'react';
import {getDateRangeOfWeek, mapCategories} from "../../helpers/utils/utils";
import {queryTransactions} from "../../Services/api";
import {mergeQuery} from "../../Services/querys";
import isThisWeek from "date-fns/isThisWeek";
import differenceInHours from "date-fns/differenceInHours";
import {format} from "date-fns";
import addHours from "date-fns/addHours";
import ActualWeek from "./ActualWeek";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";



export default function ForecastComparison({query, week, year, actualData}){
  const [lastYData, setLastYData] = useState([]);
  const [lastWData, setLastWData] = useState([]);
  const [lastYTD, setLastYTD] = useState([]);
  const [lastWTD, setLastWTD] = useState([]);
  const [prevYear, setPrevYear] = useState();
  const actualPrevYear = year - 1;
  const previousYear = prevYear || actualPrevYear;

  useEffect(
    () => {
      if (query.from && query.site) {
        queryTransactions(mergeQuery(query,{group: 'category', ...getDateRangeOfWeek(week, previousYear)})).then(data => {
          setLastYData(mapCategories(data));
        });

        queryTransactions(mergeQuery(query,{group: 'category', ...getDateRangeOfWeek(week === 1 ? 52 : week -1, year)})).then(data => {
          setLastWData(mapCategories(data));
        });

        if ( isThisWeek(new Date(query.from) )) {
          let hoursPassedThisWeek = differenceInHours(
            new Date(),
            new Date(query.from)
          );
          let lastWeek = getDateRangeOfWeek(week === 1 ? 52 : week - 1, year);
          let lastYearWeek = getDateRangeOfWeek(week, previousYear);
          lastWeek.to = format(addHours(new Date(lastWeek.from), hoursPassedThisWeek),'yyyy-MM-dd');
          lastYearWeek.to = format(addHours(new Date(lastYearWeek.from), hoursPassedThisWeek),'yyyy-MM-dd');
          queryTransactions(mergeQuery(query,{group: 'category', ...lastWeek})).then(data => {
            setLastWTD(mapCategories(data));
          });
          queryTransactions(mergeQuery(query,{group: 'category', ...lastYearWeek})).then(data => {
            setLastYTD(mapCategories(data));
          });
        } else {
          setLastYTD([]);
          setLastWTD([]);
        }
      }
    }, [query, week, year, previousYear]);

 return (
   <React.Fragment>
     <FormControl style={{minWidth:'160px', float: 'right', position: 'relative', top: -36}}>
       <InputLabel id="forecast-comparison-year-label">Previous Year</InputLabel>
       <Select
         labelId="forecast-comparison-year-label"
         id="forecast-comparison-year"
         label="Previous Year"
         value={previousYear}
         onChange={(e) => {
           const newYear = e.target.value;
           setPrevYear(newYear);
         }}
       >
          {Array.from({length: 10}, (_, i) => actualPrevYear - i).map((year, index) => (
            <MenuItem value={year} key={index}>{year}</MenuItem>
          ))}
       </Select>
     </FormControl>
   <ActualWeek week={week} year={prevYear} lastWeek={lastWData} lastYear={lastYData} lastWTD={lastWTD} lastYearWTD={lastYTD} currentWeek={actualData} />
   </React.Fragment>
 );
}
